import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';

class FMPQuickbooksClassSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const { quickbooksClasses, searchQuickbooksClasses } = this.props;
		if (_.isEmpty(quickbooksClasses)) {
			searchQuickbooksClasses({
				params: {},
			});
		}
	}

	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			readOnly,
			quickbooksClasses,
		} = this.props;

		if (!quickbooksClasses) {
			return (
				<Grid spacing={2} container>
					<Grid item xs={12} md={md}>
						<Select value={value} input={<Input id={path} readOnly={readOnly} />}>
							<MenuItem key={'loading quickbooks classes'} value={'loading'} disabled>
								Loading classes from quickbooks...
							</MenuItem>
						</Select>
					</Grid>
				</Grid>
			);
		}

		const quickbooksClassOptions = quickbooksClasses.map((quickbooksClass) => {
			const { quickbooksClassId, Name, ParentRef } = quickbooksClass;

			let display = Name;
			if (ParentRef) {
				display = <div style={{ paddingLeft: 20 }}>{Name}</div>;
			}

			return {
				value: quickbooksClassId,
				display,
			};
		});

		const hasError = !!error;
		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={md}>
					<FormControl fullWidth={true} error={hasError}>
						<InputLabel htmlFor={path}>{label}</InputLabel>
						<Select
							value={value}
							onChange={_onChange}
							input={<Input id={path} readOnly={readOnly} />}
						>
							{_.sortBy(quickbooksClassOptions, 'display').map((quickbooksClassOption) => {
								const { display, value } = quickbooksClassOption;
								return (
									<MenuItem key={value} value={value}>
										{display}
									</MenuItem>
								);
							})}
						</Select>
						{hasError && <FormHelperText>{error}</FormHelperText>}
						{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			</Grid>
		);
	}
}

FMPQuickbooksClassSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	searchQuickbooksClasses: PropTypes.func,
	quickbooksClasses: PropTypes.array,

	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
};

export default _.flow([QuickbooksContainer])(FMPQuickbooksClassSelect);
